import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper } from 'ui';
import { ChannelsDetailCard } from 'features/channels';
import { CommunityDetailsCard } from '../community-details-card';
import { CommunityFeedContent } from './community-feed-content';

export type P = {
  community: CommunityDetail;
};

const CommunityFeed = ({ community }: P) => (
  <ContentWrapper
    aside={
      <>
        {/* TODO: Will be used in Task #87927 for Community feed members card */}
        <CommunityDetailsCard community={community} />
        <ChannelsDetailCard
          channelAppearance={{ featured: community.featuredInChannels }}
          channelTags={community.tags}
          organizationId={community.organization.id}
        />
      </>
    }
  >
    {/* TODO: Will be used in Task #87927 for Community feed administrators card */}
    <CommunityFeedContent community={community} />
  </ContentWrapper>
);

export default CommunityFeed;
